import {Operando} from "./Operando";
import {Condicion} from "./Condicion";
import {Observable, Subject} from "rxjs";
import {TipoOperadorEnum} from "@shared/enums";

export class Operador implements Operando {
    public condiciones: Condicion[] = [];
    public operadores: Operador[] = [];
    public borrar$: Observable<void>;

    private _borrar$ = new Subject<void>();

    constructor(public nombre = "", private caracter = "", public tipoOperador = TipoOperadorEnum.BINARIO) {
        this.borrar$ = this._borrar$.asObservable();
    }

    public borrar() {
        this._borrar$.next();
    }

    public formateado() {
        const operandos = [
            this.condiciones.map(condicion => condicion.formateado()).join(this.caracter),
            this.operadores.map(operador => operador.formateado()).join(this.caracter)
        ];
        if (this.tipoOperador === TipoOperadorEnum.BINARIO) {
            return `(${operandos.join(this.caracter)})`;
        }
        return `${this.caracter}${operandos[0]}`;
    }

    public esElOperador(caracter: string) {
        return this.caracter === caracter;
    }

    public clone(): Operador {
        return new Operador(this.nombre, this.caracter, this.tipoOperador);
    }
}
